// extracted by mini-css-extract-plugin
export var abbr = "Markdown-module--abbr--gUiXp";
export var blockquote = "Markdown-module--blockquote--ckTT4";
export var bxTextTruncateEnd = "Markdown-module--bx--text-truncate--end--B9Fu-";
export var bxTextTruncateFront = "Markdown-module--bx--text-truncate--front--84MOO";
export var h1 = "Markdown-module--h1--tev76";
export var h2 = "Markdown-module--h2--5IV3j";
export var h3 = "Markdown-module--h3--kj+Xb";
export var h4 = "Markdown-module--h4--T9V-+";
export var h5 = "Markdown-module--h5--iCTPp";
export var h6 = "Markdown-module--h6--V0VCO";
export var list = "Markdown-module--list--famV3";
export var listItem = "Markdown-module--list-item--Fx7iu";
export var paragraph = "Markdown-module--paragraph--KTgXw";
export var paragraphResponsive = "Markdown-module--paragraph--responsive--f8rFI";
export var sup = "Markdown-module--sup--MyJhL";